"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = __importStar(require("react"));
var hooks_1 = require("../../../hooks");
var variables_1 = require("../../../style/variables");
var withLabel_1 = require("../../InputLabel/withLabel");
var Text_1 = __importDefault(require("../../Text"));
var InputContainer_1 = __importDefault(require("../_base/InputContainer"));
var TextArea = react_2.default.forwardRef(function (_a, ref) {
    var _b = _a.size, size = _b === void 0 ? 'default' : _b, error = _a.error, value = _a.value, onChange = _a.onChange, textAreaProps = _a.textAreaProps, props = __rest(_a, ["size", "error", "value", "onChange", "textAreaProps"]);
    return (react_1.jsx(InputContainer_1.default, __assign({ element: "textarea", value: value, onChange: function (e) { return onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value, e); }, css: { padding: '10px 12px' }, error: error, size: size === 'small' ? 'sm' : 'md', ref: ref }, props, textAreaProps)));
});
var InternalLabeled = withLabel_1.withLabel(TextArea);
var LabeledTextArea = function (props) {
    var _a;
    var _b = hooks_1.useDerivedState(function () { var _a; return (_a = props.value) === null || _a === void 0 ? void 0 : _a.length; }, [props.value]), charCount = _b[0], setCharCount = _b[1];
    var handleChange = function (val, e) {
        var _a;
        setCharCount((val === null || val === void 0 ? void 0 : val.length) || 0);
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, val, e);
    };
    var meta = react_2.useMemo(function () {
        var _a;
        if (((_a = props.textAreaProps) === null || _a === void 0 ? void 0 : _a.maxLength) !== undefined) {
            return (react_1.jsx(Text_1.default.Body, { color: "var(" + variables_1.ComponentColor.Form.Text.CHAR_COUNT + ")" },
                charCount,
                "/",
                props.textAreaProps.maxLength));
        }
        return null;
    }, [(_a = props.textAreaProps) === null || _a === void 0 ? void 0 : _a.maxLength, charCount]);
    return react_1.jsx(InternalLabeled, __assign({ meta: meta }, props, { onChange: handleChange }));
};
exports.default = Object.assign(TextArea, {
    Labeled: LabeledTextArea,
});
